(function () {
  const CONSUMERLITE_CHAT_WIDGET_VERSION = "V-PREMIUM-FRONTEND-POLISH-14-SEASONAL-PROMPT";

  function init() {
    if (window.__CONSUMERLITE_CHAT_WIDGET_VERSION__ === CONSUMERLITE_CHAT_WIDGET_VERSION) return;

    document.querySelectorAll(".cl-chat-launcher").forEach(function (el) {
      el.remove();
    });

    document.querySelectorAll("style[data-consumerlite-chat-style]").forEach(function (el) {
      el.remove();
    });

    window.__CONSUMERLITE_CHAT_WIDGET_VERSION__ = CONSUMERLITE_CHAT_WIDGET_VERSION;

    const CHAT_SESSION_STORAGE_KEY = "consumerlite_chat_session_v5";
    const LEGACY_CHAT_SESSION_KEYS = [
      "consumerlite_chat_session_v1",
      "consumerlite_chat_session_v2",
      "consumerlite_chat_session_v3",
      "consumerlite_chat_session_v4"
    ];
    const CHAT_SESSION_TTL_MS = 1000 * 60 * 60 * 6;
    const MAX_HISTORY_ITEMS = 24;
    const MAX_UI_ITEMS = 48;

    clearLegacyChatSessions();

    const restoredSession = loadStoredChatSession();
    const conversationHistory = Array.isArray(restoredSession.history)
      ? restoredSession.history.slice(-MAX_HISTORY_ITEMS)
      : [];
    const conversationContext = restoredSession.context && typeof restoredSession.context === "object"
      ? restoredSession.context
      : {};
    const conversationUiItems = Array.isArray(restoredSession.uiItems)
      ? restoredSession.uiItems.slice(-MAX_UI_ITEMS)
      : [];

    let lastPersistedPanelOpen = Boolean(restoredSession.panelOpen);

    const INTRO_TEXT = "Weather-aware styling. Curated luxury. Effortless shopping, tailored to you.";

    const INTRO_SUGGESTIONS = [
      {
        key: "COMPLETE_LOOK",
        label: "Complete look",
        prompt: "I want a complete outfit"
      },
      {
        key: "SEASONAL_OUTFIT",
        label: "Seasonal outfit",
        prompt: "Seasonal outfit",
        action: "SHOW_SEASONS"
      },
      {
        key: "WEATHER_OUTFIT",
        label: "Weather outfit",
        prompt: "I want a weather-aware outfit"
      },
      {
        key: "OCCASION_OUTFIT",
        label: "Occasion outfit",
        prompt: "I want an outfit for an occasion"
      },
      {
        key: "WHAT_CAN_YOU_DO",
        label: "What can you do?",
        prompt: "What can you do?"
      }
    ];


    const UI_TRANSLATIONS = {
      en: {
        PLACEHOLDER: "Ask about styling, products, occasions…",
        SEND: "Send",
        CHAT: "Chat",
        OPEN_CHAT: "Open chat",
        CLOSE: "Close",
        BETA: "Beta Online Assistant",
        ONE_MOMENT: "One moment…",
        FALLBACK: "Sorry, something went wrong. Please try again.",
        PRODUCT: "Product",
        COLLECTION: "Collection",
        VIEW_PIECE: "View piece",
        VIEW_COLLECTION: "View collection",
        TOP: "Top",
        BOTTOM: "Bottom",
        SHOES: "Shoes",
        ACCESSORY: "Accessory",
        BAG: "Bag",
        LAYER: "Layer",
        ONE_PIECE: "One piece",
        BROWSE_COLLECTIONS: "Browse collections",
        SEE_MORE: "See more",
        SEASON_PROMPT: "Which season would you like me to style an outfit for?",
        COMPLETE_LOOK: "Complete look",
        WEATHER_OUTFIT: "Weather outfit",
        OCCASION_OUTFIT: "Occasion outfit",
        SUMMER_OUTFIT: "Summer",
        SEASONAL_OUTFIT: "Seasonal outfit",
        SPRING_OUTFIT: "Spring",
        FALL_OUTFIT: "Fall",
        WINTER_OUTFIT: "Winter",
        WORK_OUTFIT: "Work outfit",
        WHAT_CAN_YOU_DO: "What can you do?",
        START_NEW_LOOK: "Start a new look",
        PRODUCT_SEARCH: "Product search",
        REROLL_OUTFIT: "Show another outfit",
        MEN: "Men",
        WOMEN: "Women"
      },
      es: {
        PLACEHOLDER: "Pregunta por estilo, productos u ocasiones…",
        SEND: "Enviar",
        CHAT: "Chat",
        OPEN_CHAT: "Abrir chat",
        CLOSE: "Cerrar",
        BETA: "Asistente en línea beta",
        ONE_MOMENT: "Un momento…",
        FALLBACK: "Lo siento, algo salió mal. Inténtalo de nuevo.",
        PRODUCT: "Producto",
        COLLECTION: "Colección",
        VIEW_PIECE: "Ver pieza",
        VIEW_COLLECTION: "Ver colección",
        TOP: "Parte superior",
        BOTTOM: "Parte inferior",
        SHOES: "Zapatos",
        ACCESSORY: "Accesorio",
        BAG: "Bolso",
        LAYER: "Capa",
        ONE_PIECE: "Una pieza",
        BROWSE_COLLECTIONS: "Ver colecciones",
        SEE_MORE: "Ver más",
        SEASON_PROMPT: "¿Para qué temporada te gustaría que creara un look?",
        COMPLETE_LOOK: "Look completo",
        WEATHER_OUTFIT: "Outfit según el clima",
        OCCASION_OUTFIT: "Outfit para ocasión",
        SUMMER_OUTFIT: "Verano",
        SEASONAL_OUTFIT: "Outfit de temporada",
        SPRING_OUTFIT: "Primavera",
        FALL_OUTFIT: "Otoño",
        WINTER_OUTFIT: "Invierno",
        WORK_OUTFIT: "Outfit para el trabajo",
        WHAT_CAN_YOU_DO: "¿Qué puedes hacer?",
        START_NEW_LOOK: "Crear otro look",
        PRODUCT_SEARCH: "Buscar producto",
        REROLL_OUTFIT: "Mostrar otro look",
        MEN: "Hombre",
        WOMEN: "Mujer"
      },
      pt: {
        PLACEHOLDER: "Pergunte sobre estilo, produtos ou ocasiões…",
        SEND: "Enviar",
        CHAT: "Chat",
        OPEN_CHAT: "Abrir chat",
        CLOSE: "Fechar",
        BETA: "Assistente online beta",
        ONE_MOMENT: "Um momento…",
        FALLBACK: "Desculpe, algo deu errado. Tente novamente.",
        PRODUCT: "Produto",
        COLLECTION: "Coleção",
        VIEW_PIECE: "Ver peça",
        VIEW_COLLECTION: "Ver coleção",
        TOP: "Parte superior",
        BOTTOM: "Parte inferior",
        SHOES: "Sapatos",
        ACCESSORY: "Acessório",
        BAG: "Bolsa",
        LAYER: "Camada",
        ONE_PIECE: "Peça única",
        BROWSE_COLLECTIONS: "Ver coleções",
        SEE_MORE: "Ver mais",
        SEASON_PROMPT: "Para qual estação você gostaria que eu criasse um look?",
        COMPLETE_LOOK: "Look completo",
        WEATHER_OUTFIT: "Look pelo clima",
        OCCASION_OUTFIT: "Look para ocasião",
        SUMMER_OUTFIT: "Verão",
        SEASONAL_OUTFIT: "Look de temporada",
        SPRING_OUTFIT: "Primavera",
        FALL_OUTFIT: "Outono",
        WINTER_OUTFIT: "Inverno",
        WORK_OUTFIT: "Look para trabalho",
        WHAT_CAN_YOU_DO: "O que você pode fazer?",
        START_NEW_LOOK: "Criar outro look",
        PRODUCT_SEARCH: "Buscar produto",
        REROLL_OUTFIT: "Mostrar outro look",
        MEN: "Homem",
        WOMEN: "Mulher"
      },
      fr: {
        PLACEHOLDER: "Demandez du style, des produits ou des occasions…",
        SEND: "Envoyer",
        CHAT: "Chat",
        OPEN_CHAT: "Ouvrir le chat",
        CLOSE: "Fermer",
        BETA: "Assistant en ligne bêta",
        ONE_MOMENT: "Un instant…",
        FALLBACK: "Désolé, une erreur s’est produite. Veuillez réessayer.",
        PRODUCT: "Produit",
        COLLECTION: "Collection",
        VIEW_PIECE: "Voir la pièce",
        VIEW_COLLECTION: "Voir la collection",
        TOP: "Haut",
        BOTTOM: "Bas",
        SHOES: "Chaussures",
        ACCESSORY: "Accessoire",
        BAG: "Sac",
        LAYER: "Couche",
        ONE_PIECE: "Une pièce",
        BROWSE_COLLECTIONS: "Voir les collections",
        SEE_MORE: "Voir plus",
        SEASON_PROMPT: "Pour quelle saison souhaitez-vous que je crée une tenue?",
        COMPLETE_LOOK: "Look complet",
        WEATHER_OUTFIT: "Tenue météo",
        OCCASION_OUTFIT: "Tenue d’occasion",
        SUMMER_OUTFIT: "Été",
        SEASONAL_OUTFIT: "Tenue saisonnière",
        SPRING_OUTFIT: "Printemps",
        FALL_OUTFIT: "Automne",
        WINTER_OUTFIT: "Hiver",
        WORK_OUTFIT: "Tenue de travail",
        WHAT_CAN_YOU_DO: "Que peux-tu faire?",
        START_NEW_LOOK: "Créer un autre look",
        PRODUCT_SEARCH: "Recherche produit",
        REROLL_OUTFIT: "Montrer une autre tenue",
        MEN: "Homme",
        WOMEN: "Femme"
      },
      it: {
        PLACEHOLDER: "Chiedi di stile, prodotti o occasioni…",
        SEND: "Invia",
        CHAT: "Chat",
        OPEN_CHAT: "Apri chat",
        CLOSE: "Chiudi",
        BETA: "Assistente online beta",
        ONE_MOMENT: "Un momento…",
        FALLBACK: "Spiacenti, qualcosa è andato storto. Riprova.",
        PRODUCT: "Prodotto",
        COLLECTION: "Collezione",
        VIEW_PIECE: "Vedi pezzo",
        VIEW_COLLECTION: "Vedi collezione",
        TOP: "Top",
        BOTTOM: "Pantaloni/Gonna",
        SHOES: "Scarpe",
        ACCESSORY: "Accessorio",
        BAG: "Borsa",
        LAYER: "Strato",
        ONE_PIECE: "Pezzo unico",
        BROWSE_COLLECTIONS: "Vedi collezioni",
        SEE_MORE: "Vedi altro",
        SEASON_PROMPT: "Per quale stagione vuoi che crei un look?",
        COMPLETE_LOOK: "Look completo",
        WEATHER_OUTFIT: "Look per il meteo",
        OCCASION_OUTFIT: "Look per occasione",
        SUMMER_OUTFIT: "Estate",
        SEASONAL_OUTFIT: "Look stagionale",
        SPRING_OUTFIT: "Primavera",
        FALL_OUTFIT: "Autunno",
        WINTER_OUTFIT: "Inverno",
        WORK_OUTFIT: "Look da lavoro",
        WHAT_CAN_YOU_DO: "Cosa puoi fare?",
        START_NEW_LOOK: "Crea un altro look",
        PRODUCT_SEARCH: "Cerca prodotto",
        REROLL_OUTFIT: "Mostra un altro look",
        MEN: "Uomo",
        WOMEN: "Donna"
      },
      de: {
        PLACEHOLDER: "Fragen Sie nach Styling, Produkten oder Anlässen…",
        SEND: "Senden",
        CHAT: "Chat",
        OPEN_CHAT: "Chat öffnen",
        CLOSE: "Schließen",
        BETA: "Beta-Online-Assistent",
        ONE_MOMENT: "Einen Moment…",
        FALLBACK: "Entschuldigung, etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
        PRODUCT: "Produkt",
        COLLECTION: "Kollektion",
        VIEW_PIECE: "Teil ansehen",
        VIEW_COLLECTION: "Kollektion ansehen",
        TOP: "Oberteil",
        BOTTOM: "Unterteil",
        SHOES: "Schuhe",
        ACCESSORY: "Accessoire",
        BAG: "Tasche",
        LAYER: "Layer",
        ONE_PIECE: "Einzelteil",
        BROWSE_COLLECTIONS: "Kollektionen ansehen",
        SEE_MORE: "Mehr sehen",
        SEASON_PROMPT: "Für welche Saison soll ich einen Look stylen?",
        COMPLETE_LOOK: "Kompletter Look",
        WEATHER_OUTFIT: "Wetter-Look",
        OCCASION_OUTFIT: "Look für Anlass",
        SUMMER_OUTFIT: "Sommer",
        SEASONAL_OUTFIT: "Saisonaler Look",
        SPRING_OUTFIT: "Frühling",
        FALL_OUTFIT: "Herbst",
        WINTER_OUTFIT: "Winter",
        WORK_OUTFIT: "Business-Look",
        WHAT_CAN_YOU_DO: "Was kannst du tun?",
        START_NEW_LOOK: "Neuen Look erstellen",
        PRODUCT_SEARCH: "Produktsuche",
        REROLL_OUTFIT: "Anderen Look anzeigen",
        MEN: "Herren",
        WOMEN: "Damen"
      },
      nl: {
        PLACEHOLDER: "Vraag naar styling, producten of gelegenheden…",
        SEND: "Versturen",
        CHAT: "Chat",
        OPEN_CHAT: "Chat openen",
        CLOSE: "Sluiten",
        BETA: "Beta online assistent",
        ONE_MOMENT: "Een moment…",
        FALLBACK: "Sorry, er ging iets mis. Probeer het opnieuw.",
        PRODUCT: "Product",
        COLLECTION: "Collectie",
        VIEW_PIECE: "Bekijk item",
        VIEW_COLLECTION: "Bekijk collectie",
        TOP: "Top",
        BOTTOM: "Onderstuk",
        SHOES: "Schoenen",
        ACCESSORY: "Accessoire",
        BAG: "Tas",
        LAYER: "Laag",
        ONE_PIECE: "One-piece",
        BROWSE_COLLECTIONS: "Collecties bekijken",
        SEE_MORE: "Meer zien",
        SEASON_PROMPT: "Voor welk seizoen wil je dat ik een look style?",
        COMPLETE_LOOK: "Complete look",
        WEATHER_OUTFIT: "Weer-look",
        OCCASION_OUTFIT: "Look voor gelegenheid",
        SUMMER_OUTFIT: "Zomer",
        SEASONAL_OUTFIT: "Seizoenslook",
        SPRING_OUTFIT: "Lente",
        FALL_OUTFIT: "Herfst",
        WINTER_OUTFIT: "Winter",
        WORK_OUTFIT: "Werklook",
        WHAT_CAN_YOU_DO: "Wat kun je doen?",
        START_NEW_LOOK: "Nieuwe look maken",
        PRODUCT_SEARCH: "Product zoeken",
        REROLL_OUTFIT: "Toon andere look",
        MEN: "Heren",
        WOMEN: "Dames"
      },
      ar: {
        PLACEHOLDER: "اسأل عن التنسيق أو المنتجات أو المناسبات…",
        SEND: "إرسال",
        CHAT: "دردشة",
        OPEN_CHAT: "فتح الدردشة",
        CLOSE: "إغلاق",
        BETA: "المساعد الإلكتروني التجريبي",
        ONE_MOMENT: "لحظة واحدة…",
        FALLBACK: "عذرًا، حدث خطأ. يرجى المحاولة مرة أخرى.",
        PRODUCT: "منتج",
        COLLECTION: "مجموعة",
        VIEW_PIECE: "عرض القطعة",
        VIEW_COLLECTION: "عرض المجموعة",
        TOP: "قطعة علوية",
        BOTTOM: "قطعة سفلية",
        SHOES: "أحذية",
        ACCESSORY: "إكسسوار",
        BAG: "حقيبة",
        LAYER: "طبقة",
        ONE_PIECE: "قطعة واحدة",
        BROWSE_COLLECTIONS: "تصفح المجموعات",
        SEE_MORE: "عرض المزيد",
        SEASON_PROMPT: "لأي موسم تريد أن أُنسّق لك إطلالة؟",
        COMPLETE_LOOK: "إطلالة كاملة",
        WEATHER_OUTFIT: "إطلالة حسب الطقس",
        OCCASION_OUTFIT: "إطلالة للمناسبة",
        SUMMER_OUTFIT: "الصيف",
        SEASONAL_OUTFIT: "إطلالة موسمية",
        SPRING_OUTFIT: "الربيع",
        FALL_OUTFIT: "الخريف",
        WINTER_OUTFIT: "الشتاء",
        WORK_OUTFIT: "إطلالة للعمل",
        WHAT_CAN_YOU_DO: "ماذا يمكنك أن تفعل؟",
        START_NEW_LOOK: "إنشاء إطلالة أخرى",
        PRODUCT_SEARCH: "بحث عن منتج",
        REROLL_OUTFIT: "عرض إطلالة أخرى",
        MEN: "رجال",
        WOMEN: "نساء"
      },
      zh: {
        PLACEHOLDER: "询问搭配、产品或场合…",
        SEND: "发送",
        CHAT: "聊天",
        OPEN_CHAT: "打开聊天",
        CLOSE: "关闭",
        BETA: "Beta 在线助手",
        ONE_MOMENT: "请稍候…",
        FALLBACK: "抱歉，出现了问题。请再试一次。",
        PRODUCT: "产品",
        COLLECTION: "系列",
        VIEW_PIECE: "查看单品",
        VIEW_COLLECTION: "查看系列",
        TOP: "上装",
        BOTTOM: "下装",
        SHOES: "鞋履",
        ACCESSORY: "配饰",
        BAG: "包袋",
        LAYER: "外搭",
        ONE_PIECE: "连体/连衣",
        BROWSE_COLLECTIONS: "浏览系列",
        SEE_MORE: "查看更多",
        SEASON_PROMPT: "你希望我为哪个季节搭配造型？",
        COMPLETE_LOOK: "完整造型",
        WEATHER_OUTFIT: "天气造型",
        OCCASION_OUTFIT: "场合造型",
        SUMMER_OUTFIT: "夏季",
        SEASONAL_OUTFIT: "季节造型",
        SPRING_OUTFIT: "春季",
        FALL_OUTFIT: "秋季",
        WINTER_OUTFIT: "冬季",
        WORK_OUTFIT: "职场造型",
        WHAT_CAN_YOU_DO: "你能做什么？",
        START_NEW_LOOK: "创建新造型",
        PRODUCT_SEARCH: "搜索产品",
        REROLL_OUTFIT: "显示另一套造型",
        MEN: "男士",
        WOMEN: "女士"
      },
      ja: {
        PLACEHOLDER: "スタイリング、商品、シーンについて質問…",
        SEND: "送信",
        CHAT: "チャット",
        OPEN_CHAT: "チャットを開く",
        CLOSE: "閉じる",
        BETA: "ベータ版オンラインアシスタント",
        ONE_MOMENT: "少々お待ちください…",
        FALLBACK: "申し訳ありません。問題が発生しました。もう一度お試しください。",
        PRODUCT: "商品",
        COLLECTION: "コレクション",
        VIEW_PIECE: "商品を見る",
        VIEW_COLLECTION: "コレクションを見る",
        TOP: "トップス",
        BOTTOM: "ボトムス",
        SHOES: "シューズ",
        ACCESSORY: "アクセサリー",
        BAG: "バッグ",
        LAYER: "レイヤー",
        ONE_PIECE: "ワンピース",
        BROWSE_COLLECTIONS: "コレクションを見る",
        SEE_MORE: "もっと見る",
        SEASON_PROMPT: "どの季節のコーデを提案しましょうか？",
        COMPLETE_LOOK: "フルコーデ",
        WEATHER_OUTFIT: "天気に合わせたコーデ",
        OCCASION_OUTFIT: "シーン別コーデ",
        SUMMER_OUTFIT: "夏",
        SEASONAL_OUTFIT: "季節のコーデ",
        SPRING_OUTFIT: "春",
        FALL_OUTFIT: "秋",
        WINTER_OUTFIT: "冬",
        WORK_OUTFIT: "仕事用コーデ",
        WHAT_CAN_YOU_DO: "何ができますか？",
        START_NEW_LOOK: "別のコーデを作る",
        PRODUCT_SEARCH: "商品検索",
        REROLL_OUTFIT: "別のコーデを見る",
        MEN: "メンズ",
        WOMEN: "ウィメンズ"
      },
      ko: {
        PLACEHOLDER: "스타일링, 상품, 상황을 물어보세요…",
        SEND: "보내기",
        CHAT: "채팅",
        OPEN_CHAT: "채팅 열기",
        CLOSE: "닫기",
        BETA: "베타 온라인 어시스턴트",
        ONE_MOMENT: "잠시만요…",
        FALLBACK: "죄송합니다. 문제가 발생했습니다. 다시 시도해 주세요.",
        PRODUCT: "상품",
        COLLECTION: "컬렉션",
        VIEW_PIECE: "상품 보기",
        VIEW_COLLECTION: "컬렉션 보기",
        TOP: "상의",
        BOTTOM: "하의",
        SHOES: "신발",
        ACCESSORY: "액세서리",
        BAG: "가방",
        LAYER: "레이어",
        ONE_PIECE: "원피스",
        BROWSE_COLLECTIONS: "컬렉션 보기",
        SEE_MORE: "더 보기",
        SEASON_PROMPT: "어느 계절의 룩을 스타일링해 드릴까요?",
        COMPLETE_LOOK: "전체 룩",
        WEATHER_OUTFIT: "날씨 맞춤 룩",
        OCCASION_OUTFIT: "상황별 룩",
        SUMMER_OUTFIT: "여름",
        SEASONAL_OUTFIT: "시즌 룩",
        SPRING_OUTFIT: "봄",
        FALL_OUTFIT: "가을",
        WINTER_OUTFIT: "겨울",
        WORK_OUTFIT: "업무 룩",
        WHAT_CAN_YOU_DO: "무엇을 할 수 있나요?",
        START_NEW_LOOK: "다른 룩 만들기",
        PRODUCT_SEARCH: "상품 검색",
        REROLL_OUTFIT: "다른 룩 보기",
        MEN: "남성",
        WOMEN: "여성"
      },
      ru: {
        PLACEHOLDER: "Спросите о стиле, товарах или случаях…",
        SEND: "Отправить",
        CHAT: "Чат",
        OPEN_CHAT: "Открыть чат",
        CLOSE: "Закрыть",
        BETA: "Бета онлайн-ассистент",
        ONE_MOMENT: "Один момент…",
        FALLBACK: "Извините, что-то пошло не так. Попробуйте еще раз.",
        PRODUCT: "Товар",
        COLLECTION: "Коллекция",
        VIEW_PIECE: "Смотреть вещь",
        VIEW_COLLECTION: "Смотреть коллекцию",
        TOP: "Верх",
        BOTTOM: "Низ",
        SHOES: "Обувь",
        ACCESSORY: "Аксессуар",
        BAG: "Сумка",
        LAYER: "Слой",
        ONE_PIECE: "Цельный образ",
        BROWSE_COLLECTIONS: "Смотреть коллекции",
        SEE_MORE: "Подробнее",
        SEASON_PROMPT: "Для какого сезона подобрать образ?",
        COMPLETE_LOOK: "Полный образ",
        WEATHER_OUTFIT: "Образ по погоде",
        OCCASION_OUTFIT: "Образ для случая",
        SUMMER_OUTFIT: "Лето",
        SEASONAL_OUTFIT: "Сезонный образ",
        SPRING_OUTFIT: "Весна",
        FALL_OUTFIT: "Осень",
        WINTER_OUTFIT: "Зима",
        WORK_OUTFIT: "Образ для работы",
        WHAT_CAN_YOU_DO: "Что ты умеешь?",
        START_NEW_LOOK: "Создать другой образ",
        PRODUCT_SEARCH: "Поиск товара",
        REROLL_OUTFIT: "Показать другой образ",
        MEN: "Мужчины",
        WOMEN: "Женщины"
      }
    };

    const UI_LANGUAGE_ALIASES = {
      eng: "en", english: "en",
      spa: "es", spanish: "es", espanol: "es", español: "es", es: "es",
      por: "pt", portuguese: "pt", portugues: "pt", português: "pt", pt: "pt",
      fre: "fr", fra: "fr", french: "fr", francais: "fr", français: "fr", fr: "fr",
      ita: "it", italian: "it", italiano: "it", it: "it",
      ger: "de", deu: "de", german: "de", deutsch: "de", de: "de",
      dutch: "nl", nederlands: "nl", nl: "nl",
      arabic: "ar", ar: "ar", عربي: "ar", العربية: "ar",
      chinese: "zh", mandarin: "zh", zh: "zh", 中文: "zh", 汉语: "zh",
      japanese: "ja", ja: "ja", 日本語: "ja",
      korean: "ko", ko: "ko", 한국어: "ko",
      russian: "ru", ru: "ru", русский: "ru"
    };

    const SUGGESTION_PROMPTS = {
      en: {
        COMPLETE_LOOK: "I want a complete outfit",
        WEATHER_OUTFIT: "I want a weather-aware outfit",
        OCCASION_OUTFIT: "I want an outfit for an occasion",
        SUMMER_OUTFIT: "I want a summer outfit",
        SEASONAL_OUTFIT: "Seasonal outfit",
        SPRING_OUTFIT: "I want a spring outfit",
        FALL_OUTFIT: "I want a fall outfit",
        WINTER_OUTFIT: "I want a winter outfit",
        WORK_OUTFIT: "I want a work outfit",
        WHAT_CAN_YOU_DO: "What can you do?",
        START_NEW_LOOK: "I want a new outfit",
        PRODUCT_SEARCH: "I am looking for a specific product",
        REROLL_OUTFIT: "Show me another outfit",
        BROWSE_COLLECTIONS: "Show me all collections",
        MEN: "men",
        WOMEN: "women"
      },
      es: {
        COMPLETE_LOOK: "Quiero un look completo",
        WEATHER_OUTFIT: "Quiero un outfit según el clima",
        OCCASION_OUTFIT: "Quiero un outfit para una ocasión",
        SUMMER_OUTFIT: "Quiero un outfit de verano",
        SEASONAL_OUTFIT: "Outfit de temporada",
        SPRING_OUTFIT: "Quiero un outfit de primavera",
        FALL_OUTFIT: "Quiero un outfit de otoño",
        WINTER_OUTFIT: "Quiero un outfit de invierno",
        WORK_OUTFIT: "Quiero un outfit para el trabajo",
        WHAT_CAN_YOU_DO: "¿Qué puedes hacer?",
        START_NEW_LOOK: "Quiero un nuevo look",
        PRODUCT_SEARCH: "Estoy buscando un producto específico",
        REROLL_OUTFIT: "Muéstrame otro look",
        BROWSE_COLLECTIONS: "Muéstrame todas las colecciones",
        MEN: "hombre",
        WOMEN: "mujer"
      },
      pt: {
        COMPLETE_LOOK: "Quero um look completo",
        WEATHER_OUTFIT: "Quero um look pelo clima",
        OCCASION_OUTFIT: "Quero um look para uma ocasião",
        SUMMER_OUTFIT: "Quero um look de verão",
        SEASONAL_OUTFIT: "Look de temporada",
        SPRING_OUTFIT: "Quero um look de primavera",
        FALL_OUTFIT: "Quero um look de outono",
        WINTER_OUTFIT: "Quero um look de inverno",
        WORK_OUTFIT: "Quero um look para trabalho",
        WHAT_CAN_YOU_DO: "O que você pode fazer?",
        START_NEW_LOOK: "Quero um novo look",
        PRODUCT_SEARCH: "Estou procurando um produto específico",
        REROLL_OUTFIT: "Mostre outro look",
        BROWSE_COLLECTIONS: "Mostre todas as coleções",
        MEN: "homem",
        WOMEN: "mulher"
      },
      fr: {
        COMPLETE_LOOK: "Je veux un look complet",
        WEATHER_OUTFIT: "Je veux une tenue selon la météo",
        OCCASION_OUTFIT: "Je veux une tenue pour une occasion",
        SUMMER_OUTFIT: "Je veux une tenue d’été",
        SEASONAL_OUTFIT: "Tenue saisonnière",
        SPRING_OUTFIT: "Je veux une tenue de printemps",
        FALL_OUTFIT: "Je veux une tenue d’automne",
        WINTER_OUTFIT: "Je veux une tenue d’hiver",
        WORK_OUTFIT: "Je veux une tenue de travail",
        WHAT_CAN_YOU_DO: "Que peux-tu faire?",
        START_NEW_LOOK: "Je veux un nouveau look",
        PRODUCT_SEARCH: "Je cherche un produit précis",
        REROLL_OUTFIT: "Montre-moi une autre tenue",
        BROWSE_COLLECTIONS: "Montre-moi toutes les collections",
        MEN: "homme",
        WOMEN: "femme"
      }
    };

    function normalizeLanguageCode(code) {
      const raw = String(code || "").trim();
      if (!raw) return "en";
      const lower = raw.toLowerCase().replace("_", "-");
      const base = lower.split("-")[0];
      return UI_LANGUAGE_ALIASES[lower] || UI_LANGUAGE_ALIASES[base] || base || "en";
    }

    function getCurrentLanguageCode() {
      const candidate =
        conversationContext.languageCode ||
        conversationContext.replyLanguageCode ||
        conversationContext.detectedLanguageCode ||
        conversationContext.language ||
        "en";
      const code = normalizeLanguageCode(candidate);
      return UI_TRANSLATIONS[code] ? code : "en";
    }

    function uiText(key) {
      const code = getCurrentLanguageCode();
      const dictionary = UI_TRANSLATIONS[code] || UI_TRANSLATIONS.en;
      return dictionary[key] || UI_TRANSLATIONS.en[key] || key;
    }

    function getLanguageDirection() {
      const code = getCurrentLanguageCode();
      return ["ar", "he", "fa", "ur"].includes(code) ? "rtl" : "ltr";
    }

    function normalizeLiteText(text) {
      return String(text || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim();
    }

    function detectUiLanguageFromText(text) {
      const raw = String(text || "").trim();
      const m = normalizeLiteText(raw);
      if (!m) return "";

      if (/\b(spanish|espanol|español|en espanol|en español|habla espanol|habla español)\b/.test(m)) return "es";
      if (/\b(portuguese|portugues|português|em portugues|em português)\b/.test(m)) return "pt";
      if (/\b(french|francais|français|en francais|en français)\b/.test(m)) return "fr";
      if (/\b(italian|italiano)\b/.test(m)) return "it";
      if (/\b(german|deutsch)\b/.test(m)) return "de";
      if (/\b(arabic|العربية|عربي)\b/.test(m)) return "ar";

      if (/\b(hola|buenos dias|buenos días|buenas tardes|buenas noches|necesito|quiero|mujer|hombre|conjunto|fiesta|zapatos|vestido)\b/.test(m)) return "es";
      if (/\b(ola|olá|bom dia|boa tarde|boa noite|preciso|quero|mulher|homem|roupa|look)\b/.test(m)) return "pt";
      if (/\b(bonjour|bonsoir|salut|je veux|j ai besoin|femme|homme|tenue)\b/.test(m)) return "fr";
      if (/\b(buongiorno|buonasera|ciao|voglio|donna|uomo|look)\b/.test(m)) return "it";
      if (/\b(guten morgen|guten tag|hallo|ich brauche|ich mochte|frau|mann)\b/.test(m)) return "de";
      if (/\b(goedemorgen|hallo|ik wil|vrouw|man)\b/.test(m)) return "nl";
      if (/\b(привет|здравствуйте|доброе утро|женщина|мужчина)\b/.test(m)) return "ru";
      if (/[\u0600-\u06FF]/.test(raw)) return "ar";
      if (/[\u4E00-\u9FFF]/.test(raw)) return "zh";
      if (/[\u3040-\u30FF]/.test(raw)) return "ja";
      if (/[\uAC00-\uD7AF]/.test(raw)) return "ko";

      return "";
    }

    function setUiLanguageFromText(text) {
      const detected = detectUiLanguageFromText(text);
      if (!detected) return;
      conversationContext.languageCode = detected;
      conversationContext.replyLanguageCode = detected;
      persistChatSession();
      applyInterfaceLocalization();
    }

    function inferSuggestionKey(label, prompt) {
      const combined = normalizeLiteText(String(label || "") + " " + String(prompt || ""));
      if (!combined) return "";

      if (/\b(complete look|complete outfit|full outfit|look completo|look complet|look completo|kompletter look|full look)\b/.test(combined)) return "COMPLETE_LOOK";
      if (/\b(weather outfit|weather-aware outfit|weather aware|clima|meteo|météo|wetter)\b/.test(combined)) return "WEATHER_OUTFIT";
      if (/\b(occasion outfit|occasion|ocasion|ocasi[oó]n|occasion|anlass)\b/.test(combined)) return "OCCASION_OUTFIT";
      if (/\b(seasonal outfit|seasonal look|season outfit|temporada|saison|stagionale|saisonaler|seizoenslook|موسمية|季节|季節|시즌|сезонный)\b/.test(combined)) return "SEASONAL_OUTFIT";
      if (/\b(spring outfit|spring look|primavera|printemps|frühling|lente|الربيع|春季|春|봄|весна)\b/.test(combined)) return "SPRING_OUTFIT";
      if (/\b(summer outfit|summer look|verano|verao|verão|ete|été|sommer|estate|zomer|الصيف|夏季|夏|여름|летний)\b/.test(combined)) return "SUMMER_OUTFIT";
      if (/\b(fall outfit|fall look|autumn outfit|autumn look|otono|otoño|outono|automne|autunno|herbst|herfst|الخريف|秋季|秋|가을|осень)\b/.test(combined)) return "FALL_OUTFIT";
      if (/\b(winter outfit|winter look|invierno|inverno|hiver|winter|الشتاء|冬季|冬|겨울|зима)\b/.test(combined)) return "WINTER_OUTFIT";
      if (/\b(work outfit|workwear|trabajo|trabalho|travail|arbeit|office|oficina)\b/.test(combined)) return "WORK_OUTFIT";
      if (/\b(what can you do|que puedes hacer|o que voce pode fazer|que peux-tu faire|cosa puoi fare|was kannst du tun)\b/.test(combined)) return "WHAT_CAN_YOU_DO";
      if (/\b(start a new look|new outfit|nuevo look|novo look|nouveau look|new look)\b/.test(combined)) return "START_NEW_LOOK";
      if (/\b(product search|specific product|buscar producto|buscar produto|produit précis)\b/.test(combined)) return "PRODUCT_SEARCH";
      if (/\b(show another outfit|another outfit|different look|reroll|otro look|outro look|autre tenue|anderer look)\b/.test(combined)) return "REROLL_OUTFIT";
      if (/\b(browse collections|show me all collections|colecciones|colecoes|coleções|collections|kollektionen)\b/.test(combined)) return "BROWSE_COLLECTIONS";
      if (/\b(men|mens|man|male|hombre|homem|homme|uomo|mann)\b/.test(combined)) return "MEN";
      if (/\b(women|womens|woman|female|mujer|mulher|femme|donna|frau)\b/.test(combined)) return "WOMEN";

      return "";
    }

    function localizeSuggestionForUi(item) {
      const normalized = normalizeSuggestion(item);
      if (!normalized) return null;

      const code = getCurrentLanguageCode();
      const labelDictionary = UI_TRANSLATIONS[code] || UI_TRANSLATIONS.en;
      const promptDictionary = SUGGESTION_PROMPTS[code] || SUGGESTION_PROMPTS.en;
      const key = normalized.key || inferSuggestionKey(normalized.label, normalized.prompt);

      if (!key) return normalized;

      const seasonalPromptFallbacks = {
        it: { SEASONAL_OUTFIT: "Look stagionale", SPRING_OUTFIT: "Voglio un look primaverile", SUMMER_OUTFIT: "Voglio un look estivo", FALL_OUTFIT: "Voglio un look autunnale", WINTER_OUTFIT: "Voglio un look invernale" },
        de: { SEASONAL_OUTFIT: "Saisonaler Look", SPRING_OUTFIT: "Ich möchte einen Frühlings-Look", SUMMER_OUTFIT: "Ich möchte einen Sommer-Look", FALL_OUTFIT: "Ich möchte einen Herbst-Look", WINTER_OUTFIT: "Ich möchte einen Winter-Look" },
        nl: { SEASONAL_OUTFIT: "Seizoenslook", SPRING_OUTFIT: "Ik wil een lentelook", SUMMER_OUTFIT: "Ik wil een zomerlook", FALL_OUTFIT: "Ik wil een herfstlook", WINTER_OUTFIT: "Ik wil een winterlook" },
        ar: { SEASONAL_OUTFIT: "إطلالة موسمية", SPRING_OUTFIT: "أريد إطلالة للربيع", SUMMER_OUTFIT: "أريد إطلالة للصيف", FALL_OUTFIT: "أريد إطلالة للخريف", WINTER_OUTFIT: "أريد إطلالة للشتاء" },
        zh: { SEASONAL_OUTFIT: "季节造型", SPRING_OUTFIT: "我想要春季造型", SUMMER_OUTFIT: "我想要夏季造型", FALL_OUTFIT: "我想要秋季造型", WINTER_OUTFIT: "我想要冬季造型" },
        ja: { SEASONAL_OUTFIT: "季節のコーデ", SPRING_OUTFIT: "春のコーデを提案して", SUMMER_OUTFIT: "夏のコーデを提案して", FALL_OUTFIT: "秋のコーデを提案して", WINTER_OUTFIT: "冬のコーデを提案して" },
        ko: { SEASONAL_OUTFIT: "시즌 룩", SPRING_OUTFIT: "봄 룩을 원해요", SUMMER_OUTFIT: "여름 룩을 원해요", FALL_OUTFIT: "가을 룩을 원해요", WINTER_OUTFIT: "겨울 룩을 원해요" },
        ru: { SEASONAL_OUTFIT: "Сезонный образ", SPRING_OUTFIT: "Хочу весенний образ", SUMMER_OUTFIT: "Хочу летний образ", FALL_OUTFIT: "Хочу осенний образ", WINTER_OUTFIT: "Хочу зимний образ" }
      };
      const seasonalPrompt = seasonalPromptFallbacks[code] && seasonalPromptFallbacks[code][key];

      return {
        key: key,
        label: labelDictionary[key] || normalized.label,
        prompt: seasonalPrompt || promptDictionary[key] || normalized.prompt,
        action: normalized.action || (key === "SEASONAL_OUTFIT" ? "SHOW_SEASONS" : ""),
        canonicalPrompt: normalized.canonicalPrompt || ""
      };
    }

    function localizeSuggestionsForUi(suggestions) {
      if (!Array.isArray(suggestions)) return [];
      return suggestions.map(localizeSuggestionForUi).filter(Boolean);
    }

    function localizeCtaForUi(cta) {
      if (!cta || typeof cta !== "object") return cta;

      const copy = Object.assign({}, cta);
      const code = getCurrentLanguageCode();
      const dictionary = UI_TRANSLATIONS[code] || UI_TRANSLATIONS.en;
      const key = inferSuggestionKey(copy.label || copy.linkText || "", "");

      if (key && dictionary[key]) copy.label = dictionary[key];
      if (/^see more$/i.test(String(copy.label || ""))) copy.label = uiText("SEE_MORE");
      if (/^browse collections$/i.test(String(copy.label || ""))) copy.label = uiText("BROWSE_COLLECTIONS");
      if (/^here$/i.test(String(copy.linkText || "")) || /^see more$/i.test(String(copy.linkText || ""))) copy.linkText = uiText("SEE_MORE");

      return copy;
    }

    function applyInterfaceLocalization() {
      const direction = getLanguageDirection();

      try {
        if (panel) panel.setAttribute("dir", direction);
        if (body) body.setAttribute("dir", direction);
        if (input) {
          input.placeholder = uiText("PLACEHOLDER");
          input.setAttribute("aria-label", uiText("PLACEHOLDER"));
          input.setAttribute("dir", direction);
        }
        if (send) send.textContent = uiText("SEND");
        if (btn) {
          btn.textContent = uiText("CHAT");
          btn.setAttribute("aria-label", uiText("OPEN_CHAT"));
        }
        if (closeBtn) closeBtn.setAttribute("aria-label", uiText("CLOSE"));
        const sub = launcher ? launcher.querySelector(".cl-chat-sub") : null;
        if (sub) sub.textContent = uiText("BETA");
      } catch (e) {}
    }


    const STYLE = `
      .cl-chat-launcher{
        position:fixed;
        right:22px;
        bottom:22px;
        z-index:2147483647;
        font-family: Georgia, "Times New Roman", serif;
      }

      [data-consumerlite-chat-open]{
        cursor:pointer;
      }

      .cl-chat-btn{
        width:58px;
        height:58px;
        border-radius:999px;
        border:1px solid rgba(255,255,255,.16);
        cursor:pointer;
        box-shadow:0 18px 46px rgba(0,0,0,.22);
        background:#101010;
        color:#fff;
        font:700 12px/1.1 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        letter-spacing:.02em;
        transition:transform .22s ease, box-shadow .22s ease, background .22s ease;
      }

      .cl-chat-btn:hover{
        transform:translateY(-2px);
        box-shadow:0 22px 56px rgba(0,0,0,.28);
        background:#000;
      }

      .cl-chat-panel{
        position:fixed;
        right:22px;
        bottom:92px;
        width:410px;
        max-width:92vw;
        height:660px;
        max-height:80vh;
        background:#fff;
        border:1px solid rgba(0,0,0,.10);
        border-radius:24px;
        box-shadow:0 28px 80px rgba(0,0,0,.24);
        overflow:hidden;
        display:none;
        z-index:2147483647;
        animation:clPanelIn .24s ease both;
      }

      @keyframes clPanelIn{
        from{ opacity:0; transform:translateY(12px) scale(.985); }
        to{ opacity:1; transform:translateY(0) scale(1); }
      }

      .cl-chat-head{
        padding:18px 18px 15px;
        border-bottom:1px solid rgba(0,0,0,.08);
        display:flex;
        align-items:center;
        justify-content:space-between;
        background:linear-gradient(180deg,#fff 0%,#fbfaf8 100%);
      }

      .cl-chat-brand{
        display:flex;
        flex-direction:column;
        gap:4px;
      }

      .cl-chat-title{
        font:700 14px/1.1 Georgia, "Times New Roman", serif;
        letter-spacing:.20em;
        text-transform:uppercase;
        color:#111;
      }

      .cl-chat-sub{
        font:500 12px/1.2 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        color:rgba(0,0,0,.52);
        letter-spacing:.01em;
      }

      .cl-chat-close{
        width:32px;
        height:32px;
        border-radius:999px;
        border:1px solid transparent;
        background:transparent;
        font-size:22px;
        line-height:1;
        cursor:pointer;
        color:rgba(0,0,0,.55);
        transition:background .18s ease, border-color .18s ease, color .18s ease;
      }

      .cl-chat-close:hover{
        background:#f4f1ed;
        border-color:rgba(0,0,0,.08);
        color:#111;
      }

      .cl-chat-body{
        height:calc(100% - 66px - 82px);
        padding:16px 14px 18px;
        overflow:auto;
        background:
          radial-gradient(circle at 20% 0%, rgba(180,160,130,.12), transparent 30%),
          linear-gradient(180deg,#fff 0%,#fbfaf8 100%);
        position:relative;
        z-index:2147483647;
        pointer-events:auto;
        scroll-behavior:smooth;
      }

      .cl-chat-body::-webkit-scrollbar{
        width:8px;
      }

      .cl-chat-body::-webkit-scrollbar-track{
        background:transparent;
      }

      .cl-chat-body::-webkit-scrollbar-thumb{
        background:rgba(0,0,0,.16);
        border-radius:999px;
      }

      .cl-msg{
        margin:12px 0;
        display:flex;
        animation:clMsgIn .20s ease both;
      }

      @keyframes clMsgIn{
        from{ opacity:0; transform:translateY(6px); }
        to{ opacity:1; transform:translateY(0); }
      }

      .cl-msg.user{
        justify-content:flex-end;
      }

      .cl-bubble{
        max-width:86%;
        padding:12px 14px;
        border-radius:18px;
        font:500 14px/1.58 Georgia, "Times New Roman", serif;
        white-space:pre-wrap;
        box-sizing:border-box;
      }

      .cl-msg.ai .cl-bubble{
        background:#101010;
        color:#fff;
        border-top-left-radius:7px;
        box-shadow:0 14px 34px rgba(0,0,0,.14);
      }

      .cl-msg.user .cl-bubble{
        background:#f0efed;
        color:#111;
        border-top-right-radius:7px;
        box-shadow:0 8px 22px rgba(0,0,0,.04);
      }

      .cl-suggestions{
        display:flex;
        flex-wrap:wrap;
        gap:9px;
        margin:10px 0 14px;
        padding-left:2px;
        position:relative;
        z-index:2147483647;
      }

      .cl-suggestion{
        border:1px solid rgba(0,0,0,.16);
        border-radius:999px;
        background:rgba(255,255,255,.92);
        color:#111;
        padding:9px 12px;
        font:700 11px/1.15 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        letter-spacing:.01em;
        cursor:pointer;
        box-shadow:0 8px 22px rgba(0,0,0,.055);
        transition:transform .18s ease, background .18s ease, color .18s ease, border-color .18s ease;
      }

      .cl-suggestion:hover{
        transform:translateY(-1px);
        background:#111;
        color:#fff;
        border-color:#111;
      }

      .cl-chat-foot{
        border-top:1px solid rgba(0,0,0,.08);
        padding:12px;
        display:flex;
        gap:10px;
        background:#fff;
        align-items:center;
      }

      .cl-in{
        flex:1;
        min-width:0;
        border:1px solid rgba(0,0,0,.15);
        border-radius:999px;
        padding:13px 15px;
        font:500 14px/1.2 Georgia, "Times New Roman", serif;
        outline:none;
        background:#fff;
        color:#111;
        transition:border-color .18s ease, box-shadow .18s ease;
      }

      .cl-in:focus{
        border-color:#111;
        box-shadow:0 0 0 3px rgba(0,0,0,.06);
      }

      .cl-in::placeholder{
        color:rgba(0,0,0,.42);
      }

      .cl-send{
        border:0;
        border-radius:999px;
        padding:13px 17px;
        background:#111;
        color:#fff;
        font:800 13px/1 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        cursor:pointer;
        min-width:66px;
        transition:transform .18s ease, box-shadow .18s ease, background .18s ease;
      }

      .cl-send:hover{
        transform:translateY(-1px);
        box-shadow:0 12px 26px rgba(0,0,0,.18);
        background:#000;
      }

      .cl-cards{
        display:grid;
        grid-template-columns:repeat(2,minmax(0,1fr));
        gap:12px;
        margin:13px 0 4px;
        position:relative;
        z-index:2147483647;
        pointer-events:auto;
      }

      .cl-card{
        display:flex;
        flex-direction:column;
        min-height:100%;
        border:1px solid rgba(0,0,0,.10);
        border-radius:20px;
        overflow:hidden;
        background:#fff;
        text-decoration:none;
        color:#111;
        position:relative;
        z-index:2147483647;
        pointer-events:auto;
        cursor:pointer;
        -webkit-tap-highlight-color:transparent;
        box-shadow:0 12px 34px rgba(0,0,0,.045);
        transition:transform .22s ease, box-shadow .22s ease, border-color .22s ease;
      }

      .cl-card:hover{
        transform:translateY(-3px);
        box-shadow:0 18px 44px rgba(0,0,0,.11);
        border-color:rgba(0,0,0,.18);
      }

      .cl-card-img{
        width:100%;
        height:178px;
        object-fit:contain;
        display:block;
        background:#f5f3f0;
        padding:12px;
        box-sizing:border-box;
        border-bottom:1px solid rgba(0,0,0,.06);
      }

      .cl-card-body{
        padding:12px 12px 13px;
        display:flex;
        flex-direction:column;
        flex:1;
      }

      .cl-card-badge{
        align-self:flex-start;
        margin:0 0 8px;
        padding:5px 8px;
        border:1px solid rgba(0,0,0,.12);
        border-radius:999px;
        background:#fbfaf8;
        color:rgba(0,0,0,.62);
        font:800 9px/1 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        letter-spacing:.12em;
        text-transform:uppercase;
      }

      .cl-card-title{
        font:700 13px/1.34 Georgia, "Times New Roman", serif;
        letter-spacing:.01em;
        margin:0 0 7px;
        color:#111;
      }

      .cl-card-price{
        font:700 12px/1.2 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        color:rgba(0,0,0,.58);
        margin:0;
      }

      .cl-card-action{
        margin-top:auto;
        padding-top:10px;
        font:800 10px/1 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        letter-spacing:.12em;
        text-transform:uppercase;
        color:#111;
      }

      .cl-browse{
        display:block;
        margin:10px 0 0;
        font:800 12px/1.2 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        text-decoration:underline;
        color:#111;
        position:relative;
        z-index:2147483647;
        pointer-events:auto;
        cursor:pointer;
      }

      .cl-guide-cta{
        text-decoration:none;
        color:rgba(0,0,0,.72);
        font:700 12px/1.35 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        margin:12px 0 2px;
      }

      .cl-guide-cta a{
        color:#111;
        text-decoration:underline;
        font-weight:900;
      }

      @media (max-width: 640px){
        .cl-chat-launcher{
          right:16px;
          bottom:16px;
        }

        .cl-chat-btn{
          width:56px;
          height:56px;
        }

        .cl-chat-panel{
          left:8px;
          right:8px;
          bottom:78px;
          width:auto;
          max-width:none;
          height:min(650px, calc(100dvh - 96px));
          max-height:calc(100dvh - 96px);
          border-radius:22px;
        }

        .cl-chat-head{
          padding:15px 15px 13px;
        }

        .cl-chat-body{
          height:calc(100% - 61px - 76px);
          padding:13px 10px 14px;
        }

        .cl-bubble{
          max-width:88%;
          font-size:14px;
          padding:11px 13px;
        }

        .cl-cards{
          grid-template-columns:repeat(2,minmax(0,1fr));
          gap:10px;
        }

        .cl-card{
          border-radius:18px;
        }

        .cl-card-img{
          height:154px;
          padding:10px;
        }

        .cl-card-body{
          padding:10px;
        }

        .cl-card-title{
          font-size:12px;
        }

        .cl-suggestions{
          gap:8px;
        }

        .cl-suggestion{
          padding:8px 10px;
          font-size:10.5px;
        }

        .cl-chat-foot{
          padding:10px;
          gap:8px;
        }

        .cl-in{
          padding:12px 13px;
          font-size:14px;
        }

        .cl-send{
          min-width:64px;
          padding:12px 14px;
        }
      }

      @media (max-width: 390px){
        .cl-card-img{
          height:138px;
        }

        .cl-card-title{
          font-size:11.5px;
        }
      }
    `;

    const elStyle = document.createElement("style");
    elStyle.setAttribute("data-consumerlite-chat-style", CONSUMERLITE_CHAT_WIDGET_VERSION);
    elStyle.textContent = STYLE;
    document.head.appendChild(elStyle);

    const launcher = document.createElement("div");
    launcher.className = "cl-chat-launcher";
    launcher.innerHTML = `
      <button class="cl-chat-btn" aria-label="Open chat" type="button">Chat</button>
      <div class="cl-chat-panel" role="dialog" aria-label="Consumerlite chat">
        <div class="cl-chat-head">
          <div class="cl-chat-brand">
            <div class="cl-chat-title">Consumerlite</div>
            <div class="cl-chat-sub">Beta Online Assistant</div>
          </div>
          <button class="cl-chat-close" aria-label="Close" type="button">×</button>
        </div>
        <div class="cl-chat-body"></div>
        <div class="cl-chat-foot">
          <input class="cl-in" placeholder="Ask about styling, products, occasions…" />
          <button class="cl-send" type="button">Send</button>
        </div>
      </div>
    `;
    document.body.appendChild(launcher);

    const btn = launcher.querySelector(".cl-chat-btn");
    const panel = launcher.querySelector(".cl-chat-panel");
    const closeBtn = launcher.querySelector(".cl-chat-close");
    const body = launcher.querySelector(".cl-chat-body");
    const input = launcher.querySelector(".cl-in");
    const send = launcher.querySelector(".cl-send");

    applyInterfaceLocalization();

    function clearLegacyChatSessions() {
      try {
        if (!window.sessionStorage || !Array.isArray(LEGACY_CHAT_SESSION_KEYS)) return;
        LEGACY_CHAT_SESSION_KEYS.forEach(function (key) {
          try { window.sessionStorage.removeItem(key); } catch (e) {}
        });
      } catch (e) {}
    }

    function getSessionNow() {
      return Date.now ? Date.now() : new Date().getTime();
    }

    function loadStoredChatSession() {
      try {
        if (!window.sessionStorage) return {};

        const raw = window.sessionStorage.getItem(CHAT_SESSION_STORAGE_KEY);
        if (!raw) return {};

        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== "object") return {};

        if (parsed.version !== CONSUMERLITE_CHAT_WIDGET_VERSION) {
          window.sessionStorage.removeItem(CHAT_SESSION_STORAGE_KEY);
          return {};
        }

        const savedAt = Number(parsed.savedAt || 0);
        if (savedAt && getSessionNow() - savedAt > CHAT_SESSION_TTL_MS) {
          window.sessionStorage.removeItem(CHAT_SESSION_STORAGE_KEY);
          return {};
        }

        return parsed;
      } catch (e) {
        return {};
      }
    }

    function compactHistoryForStorage(history) {
      if (!Array.isArray(history)) return [];

      return history
        .map(function (item) {
          return {
            role: normalizeRole(item && item.role ? item.role : ""),
            text: String(item && item.text ? item.text : "").slice(0, 1800)
          };
        })
        .filter(function (item) {
          return item.role && item.text;
        })
        .slice(-MAX_HISTORY_ITEMS);
    }

    function compactContextForStorage(context) {
      if (!context || typeof context !== "object") return {};

      const clone = {};
      Object.keys(context).forEach(function (key) {
        const value = context[key];

        if (key === "lastProducts" && Array.isArray(value)) {
          clone[key] = value.slice(0, 6);
          return;
        }

        if (key === "lastCollections" && Array.isArray(value)) {
          clone[key] = value.slice(0, 12);
          return;
        }

        if (key === "recentProductHandles" && Array.isArray(value)) {
          clone[key] = value.map(String).filter(Boolean).slice(0, 30);
          return;
        }

        if (typeof value === "string") {
          clone[key] = value.slice(0, 1800);
          return;
        }

        if (typeof value === "number" || typeof value === "boolean" || value === null) {
          clone[key] = value;
          return;
        }

        if (Array.isArray(value)) {
          clone[key] = value.slice(0, 24);
          return;
        }

        if (value && typeof value === "object") {
          clone[key] = value;
        }
      });

      return clone;
    }

    function compactUiItemsForStorage(items) {
      if (!Array.isArray(items)) return [];

      return items
        .map(function (item) {
          if (!item || typeof item !== "object") return null;

          if (item.type === "msg") {
            return {
              type: "msg",
              role: item.role === "user" ? "user" : "ai",
              text: String(item.text || "").slice(0, 1800)
            };
          }

          if (item.type === "products") {
            return {
              type: "products",
              products: Array.isArray(item.products) ? item.products.slice(0, 6) : []
            };
          }

          if (item.type === "collections") {
            return {
              type: "collections",
              collectionCards: Array.isArray(item.collectionCards) ? item.collectionCards.slice(0, 12) : []
            };
          }

          if (item.type === "cta") {
            return {
              type: "cta",
              cta: item.cta && typeof item.cta === "object" ? item.cta : null
            };
          }

          if (item.type === "suggestions") {
            return {
              type: "suggestions",
              suggestions: Array.isArray(item.suggestions) ? item.suggestions.slice(0, 6) : []
            };
          }

          return null;
        })
        .filter(Boolean)
        .slice(-MAX_UI_ITEMS);
    }

    function persistChatSession() {
      try {
        if (!window.sessionStorage) return;

        const payload = {
          version: CONSUMERLITE_CHAT_WIDGET_VERSION,
          savedAt: getSessionNow(),
          panelOpen: lastPersistedPanelOpen,
          history: compactHistoryForStorage(conversationHistory),
          context: compactContextForStorage(conversationContext),
          uiItems: compactUiItemsForStorage(conversationUiItems)
        };

        window.sessionStorage.setItem(CHAT_SESSION_STORAGE_KEY, JSON.stringify(payload));
      } catch (e) {}
    }

    function addUiItem(item) {
      if (!item || typeof item !== "object") return;

      conversationUiItems.push(item);

      if (conversationUiItems.length > MAX_UI_ITEMS) {
        conversationUiItems.splice(0, conversationUiItems.length - MAX_UI_ITEMS);
      }

      persistChatSession();
    }

    function removeExtraUiItems() {
      for (let i = conversationUiItems.length - 1; i >= 0; i--) {
        const type = conversationUiItems[i] && conversationUiItems[i].type;
        if (type === "products" || type === "collections" || type === "cta" || type === "suggestions") {
          conversationUiItems.splice(i, 1);
        }
      }

      persistChatSession();
    }

    function resetStoredChatSession() {
      try {
        if (window.sessionStorage) {
          window.sessionStorage.removeItem(CHAT_SESSION_STORAGE_KEY);
          clearLegacyChatSessions();
        }
      } catch (e) {}

      conversationHistory.splice(0, conversationHistory.length);
      Object.keys(conversationContext).forEach(function (key) {
        delete conversationContext[key];
      });
      conversationUiItems.splice(0, conversationUiItems.length);
      lastPersistedPanelOpen = false;

      if (body) {
        body.innerHTML = "";
        delete body.dataset.inited;
      }
    }

    function sanitizeReplyText(text) {
      return String(text || "")
        .replace(/\r/g, "")
        .replace(/\*\*(.*?)\*\*/g, "$1")
        .replace(/\*(.*?)\*/g, "$1")
        .replace(/__(.*?)__/g, "$1")
        .replace(/_(.*?)_/g, "$1")
        .replace(/`{1,3}([^`]*)`{1,3}/g, "$1")
        .replace(/\[(.*?)\]\((.*?)\)/g, "$1")
        .replace(/^#{1,6}\s*/gm, "")
        .replace(/\n{3,}/g, "\n\n")
        .trim();
    }

    function normalizeRole(role) {
      const cleanRole = String(role || "").toLowerCase();
      if (["user", "customer", "visitor", "human", "me"].includes(cleanRole)) return "user";
      if (["ai", "assistant", "bot", "system", "consumerlite"].includes(cleanRole)) return "assistant";
      return cleanRole || "user";
    }

    function pushHistory(role, text) {
      const normalizedRole = normalizeRole(role);
      const cleanText = String(text || "").trim();
      if (!cleanText) return;

      conversationHistory.push({
        role: normalizedRole,
        text: cleanText
      });

      if (conversationHistory.length > MAX_HISTORY_ITEMS) {
        conversationHistory.splice(0, conversationHistory.length - MAX_HISTORY_ITEMS);
      }

      persistChatSession();
    }

    function isAudienceOnlyText(text) {
      const clean = normalizeLiteText(text);
      return /^(men|mens|man|male|hombre|homem|homme|uomo|mann|manne|mujer|mulher|femme|donna|frau|women|womens|woman|female|kids|kid|baby|boys|boy|girls|girl)$/i.test(clean);
    }

    function isGenderGateReply(text) {
      const clean = normalizeLiteText(text);
      return (
        clean.includes("is this for men or women") ||
        clean.includes("es para hombre o mujer") ||
        clean.includes("e para homem ou mulher") ||
        clean.includes("est-ce pour homme ou femme") ||
        clean.includes("homme ou femme") ||
        clean.includes("uomo o donna") ||
        clean.includes("mann oder frau") ||
        clean.includes("men or women") ||
        clean.includes("hombre o mujer") ||
        clean.includes("homem ou mulher")
      );
    }

    function findLastMeaningfulUserRequest(excludeLatestAudienceOnly) {
      for (let i = conversationHistory.length - 1; i >= 0; i--) {
        const item = conversationHistory[i] || {};
        const role = normalizeRole(item.role || "");
        const text = String(item.text || "").trim();

        if (role !== "user") continue;
        if (!text) continue;
        if (excludeLatestAudienceOnly && isAudienceOnlyText(text)) continue;

        return text;
      }

      return "";
    }

    function rememberPendingRequestIfNeeded(userText, assistantReply) {
      const cleanUserText = String(userText || "").trim();
      const cleanReply = String(assistantReply || "").toLowerCase();

      if (!cleanUserText) return;

      conversationContext.lastUserMessage = cleanUserText;

      if (isGenderGateReply(cleanReply)) {
        const priorRequest = isAudienceOnlyText(cleanUserText)
          ? findLastMeaningfulUserRequest(true)
          : cleanUserText;

        if (priorRequest) {
          conversationContext.pendingRequest = priorRequest;
          conversationContext.originalRequest = priorRequest;
          conversationContext.lastMeaningfulUserText = priorRequest;
        }
      }

      if (!isAudienceOnlyText(cleanUserText)) {
        conversationContext.lastMeaningfulUserText = cleanUserText;
      }

      persistChatSession();
    }

    function mergeContextFromWorker(data) {
      if (!data || typeof data !== "object") return;

      if (data.context && typeof data.context === "object") {
        Object.assign(conversationContext, data.context);
      }

      if (data.contextPatch && typeof data.contextPatch === "object") {
        Object.assign(conversationContext, data.contextPatch);
      }

      if (Array.isArray(data.products) && data.products.length > 0) {
        conversationContext.lastProducts = data.products;
        conversationContext.recentProductHandles = data.products
          .map(function (p) { return p && p.handle ? String(p.handle) : ""; })
          .filter(Boolean)
          .concat(Array.isArray(conversationContext.recentProductHandles) ? conversationContext.recentProductHandles : [])
          .slice(0, 24);
        delete conversationContext.pendingRequest;
      }

      if (Array.isArray(data.collectionCards) && data.collectionCards.length > 0) {
        conversationContext.lastCollections = data.collectionCards;
      }

      applyInterfaceLocalization();
      persistChatSession();
    }

    function addMsg(role, text, options) {
      const row = document.createElement("div");
      row.className = "cl-msg " + role;

      const bubble = document.createElement("div");
      bubble.className = "cl-bubble";
      bubble.textContent = role === "ai" ? sanitizeReplyText(text) : String(text || "");

      row.appendChild(bubble);
      body.appendChild(row);
      body.scrollTop = body.scrollHeight;

      const shouldPersist = !options || options.persist !== false;
      if (shouldPersist) {
        addUiItem({
          type: "msg",
          role: role === "user" ? "user" : "ai",
          text: role === "ai" ? sanitizeReplyText(text) : String(text || "")
        });
      }

      return bubble;
    }

    function clearOldExtras() {
      body.querySelectorAll(".cl-cards, .cl-browse, .cl-suggestions").forEach(function (el) {
        el.remove();
      });

      removeExtraUiItems();
    }

    function safeUrl(u) {
      if (!u) return "";
      try {
        const parsed = new URL(u, window.location.origin);
        if (parsed.protocol === "http:" || parsed.protocol === "https:") {
          return parsed.toString();
        }
      } catch (e) {}
      return "";
    }

    function normalizeSuggestion(item) {
      if (!item) return null;

      if (typeof item === "string") {
        return { key: inferSuggestionKey(item, item), label: item, prompt: item };
      }

      if (typeof item === "object") {
        const label = String(item.label || item.title || item.text || item.prompt || "").trim();
        const prompt = String(item.prompt || item.message || item.value || label || "").trim();
        const key = String(item.key || item.id || "").trim() || inferSuggestionKey(label, prompt);
        const action = String(item.action || "").trim();
        const canonicalPrompt = String(item.canonicalPrompt || "").trim();
        if (!label || !prompt) return null;
        return { key: key, label: label, prompt: prompt, action: action, canonicalPrompt: canonicalPrompt };
      }

      return null;
    }

    function removeSuggestionUiItemsOnly() {
      for (let i = conversationUiItems.length - 1; i >= 0; i--) {
        const type = conversationUiItems[i] && conversationUiItems[i].type;
        if (type === "suggestions") {
          conversationUiItems.splice(i, 1);
        }
      }

      persistChatSession();
    }

    function localizeUiText(key) {
      const code = getCurrentLanguageCode();
      const labelDictionary = UI_TRANSLATIONS[code] || UI_TRANSLATIONS.en;
      return labelDictionary[key] || UI_TRANSLATIONS.en[key] || "";
    }

    function getSeasonalOutfitSuggestions() {
      return [
        { key: "SPRING_OUTFIT", label: "Spring", prompt: "I want a spring outfit", canonicalPrompt: "I want a spring outfit" },
        { key: "SUMMER_OUTFIT", label: "Summer", prompt: "I want a summer outfit", canonicalPrompt: "I want a summer outfit" },
        { key: "FALL_OUTFIT", label: "Fall", prompt: "I want a fall outfit", canonicalPrompt: "I want a fall outfit" },
        { key: "WINTER_OUTFIT", label: "Winter", prompt: "I want a winter outfit", canonicalPrompt: "I want a winter outfit" }
      ];
    }

    function showSeasonalOutfitChoices() {
      body.querySelectorAll(".cl-suggestions").forEach(function (el) {
        el.remove();
      });

      removeSuggestionUiItemsOnly();
      addMsg("ai", localizeUiText("SEASON_PROMPT") || "Which season would you like me to style an outfit for?");
      pushHistory("assistant", localizeUiText("SEASON_PROMPT") || "Which season would you like me to style an outfit for?");
      addSuggestions(getSeasonalOutfitSuggestions());
    }

    function addSuggestions(suggestions, options) {
      if (!Array.isArray(suggestions) || suggestions.length === 0) return;

      const wrap = document.createElement("div");
      wrap.className = "cl-suggestions";

      localizeSuggestionsForUi(suggestions).slice(0, 6).forEach(function (item) {
        const suggestion = normalizeSuggestion(item);
        if (!suggestion) return;

        const chip = document.createElement("button");
        chip.type = "button";
        chip.className = "cl-suggestion";
        chip.textContent = suggestion.label;
        chip.setAttribute("aria-label", suggestion.label);

        chip.addEventListener("click", function () {
          if (suggestion.action === "SHOW_SEASONS" || suggestion.key === "SEASONAL_OUTFIT") {
            showSeasonalOutfitChoices();
            return;
          }

          input.value = suggestion.prompt;
          doSend();
        });

        wrap.appendChild(chip);
      });

      if (wrap.childNodes.length) {
        body.appendChild(wrap);
        body.scrollTop = body.scrollHeight;

        if (!options || options.persist !== false) {
          addUiItem({
            type: "suggestions",
            suggestions: localizeSuggestionsForUi(suggestions).slice(0, 6)
          });
        }
      }
    }

    function addCta(cta, options) {
      cta = localizeCtaForUi(cta);
      if (!cta || !cta.url) return;

      const href = safeUrl(cta.url);
      if (!href) return;

      const prefix = String(cta.prefix || "").trim();
      const linkText = String(cta.linkText || "").trim();

      if (prefix && linkText) {
        const wrap = document.createElement("div");
        wrap.className = "cl-browse cl-guide-cta";

        // Keep a visible space before the clickable word.
        // Example: "see how here" instead of "see howhere".
        wrap.appendChild(document.createTextNode(prefix + " "));

        const a = document.createElement("a");
        a.href = href;
        a.textContent = linkText;
        a.setAttribute("aria-label", String(cta.label || linkText));

        a.addEventListener("click", function (ev) {
          if (ev.defaultPrevented) return;
          window.location.href = href;
        });

        wrap.appendChild(a);
        body.appendChild(wrap);
        body.scrollTop = body.scrollHeight;

        if (!options || options.persist !== false) {
          addUiItem({ type: "cta", cta: cta });
        }

        return;
      }

      const a = document.createElement("a");
      a.className = "cl-browse";
      a.href = href;
      a.textContent = cta.label ? String(cta.label) : uiText("BROWSE_COLLECTIONS");

      a.addEventListener("click", function (ev) {
        if (ev.defaultPrevented) return;
        window.location.href = href;
      });

      body.appendChild(a);
      body.scrollTop = body.scrollHeight;

      if (!options || options.persist !== false) {
        addUiItem({ type: "cta", cta: cta });
      }
    }

    function formatProductSlotLabel(slot) {
      const clean = String(slot || "").toLowerCase().trim();

      const labels = {
        top: "TOP",
        bottom: "BOTTOM",
        shoes: "SHOES",
        accessory: "ACCESSORY",
        accessories: "ACCESSORY",
        bag: "BAG",
        layer: "LAYER",
        onepiece: "ONE_PIECE",
        one_piece: "ONE_PIECE"
      };

      return labels[clean] ? uiText(labels[clean]) : "";
    }

    function addProductCards(products, options) {
      if (!Array.isArray(products) || products.length === 0) return;

      const grid = document.createElement("div");
      grid.className = "cl-cards";

      products.slice(0, 6).forEach(function (p) {
        const href = safeUrl(p && p.url);
        if (!href) return;

        const a = document.createElement("a");
        a.className = "cl-card";
        a.href = href;

        a.addEventListener("click", function (ev) {
          if (ev.defaultPrevented) return;
          window.location.href = href;
        });

        const img = document.createElement("img");
        img.className = "cl-card-img";
        img.alt = p && (p.imageAlt || p.title) ? (p.imageAlt || p.title) : uiText("PRODUCT");
        img.loading = "lazy";
        img.decoding = "async";
        img.referrerPolicy = "no-referrer";

        const src = p && p.image ? String(p.image) : "";
        img.src = safeUrl(src) || "";
        a.appendChild(img);

        const cardBody = document.createElement("div");
        cardBody.className = "cl-card-body";

        const slotLabel = formatProductSlotLabel(p && p.outfitSlot ? p.outfitSlot : "");
        if (slotLabel) {
          const badge = document.createElement("div");
          badge.className = "cl-card-badge";
          badge.textContent = slotLabel;
          cardBody.appendChild(badge);
        }

        const title = document.createElement("p");
        title.className = "cl-card-title";
        title.textContent = p && p.title ? String(p.title) : uiText("PRODUCT");
        cardBody.appendChild(title);

        const price = document.createElement("p");
        price.className = "cl-card-price";
        price.textContent = p && p.price ? String(p.price) : "";
        cardBody.appendChild(price);

        const action = document.createElement("div");
        action.className = "cl-card-action";
        action.textContent = uiText("VIEW_PIECE");
        cardBody.appendChild(action);

        a.appendChild(cardBody);
        grid.appendChild(a);
      });

      body.appendChild(grid);
      body.scrollTop = body.scrollHeight;

      if (!options || options.persist !== false) {
        addUiItem({
          type: "products",
          products: products.slice(0, 6)
        });
      }
    }

    function addCollectionCards(collectionCards, options) {
      if (!Array.isArray(collectionCards) || collectionCards.length === 0) return;

      const grid = document.createElement("div");
      grid.className = "cl-cards";

      collectionCards.slice(0, 12).forEach(function (c) {
        const href = safeUrl(c && c.url);
        if (!href) return;

        const a = document.createElement("a");
        a.className = "cl-card";
        a.href = href;

        a.addEventListener("click", function (ev) {
          if (ev.defaultPrevented) return;
          window.location.href = href;
        });

        const img = document.createElement("img");
        img.className = "cl-card-img";
        img.alt = c && (c.imageAlt || c.title) ? (c.imageAlt || c.title) : uiText("COLLECTION");
        img.loading = "lazy";
        img.decoding = "async";
        img.referrerPolicy = "no-referrer";

        const src = c && c.image ? String(c.image) : "";
        img.src = safeUrl(src) || "";
        a.appendChild(img);

        const cardBody = document.createElement("div");
        cardBody.className = "cl-card-body";

        const title = document.createElement("p");
        title.className = "cl-card-title";
        title.textContent = c && c.title ? String(c.title) : uiText("COLLECTION");
        cardBody.appendChild(title);

        const action = document.createElement("div");
        action.className = "cl-card-action";
        action.textContent = uiText("VIEW_COLLECTION");
        cardBody.appendChild(action);

        a.appendChild(cardBody);
        grid.appendChild(a);
      });

      body.appendChild(grid);
      body.scrollTop = body.scrollHeight;

      if (!options || options.persist !== false) {
        addUiItem({
          type: "collections",
          collectionCards: collectionCards.slice(0, 12)
        });
      }
    }

    function restoreChatBodyFromSession() {
      if (body.dataset.inited) return;

      body.dataset.inited = "1";

      if (!conversationUiItems.length) {
        addMsg("ai", INTRO_TEXT);
        pushHistory("assistant", INTRO_TEXT);
        addSuggestions(localizeSuggestionsForUi(INTRO_SUGGESTIONS));
        return;
      }

      conversationUiItems.forEach(function (item) {
        if (!item || typeof item !== "object") return;

        if (item.type === "msg") {
          addMsg(item.role === "user" ? "user" : "ai", item.text || "", { persist: false });
          return;
        }

        if (item.type === "products") {
          addProductCards(item.products || [], { persist: false });
          return;
        }

        if (item.type === "collections") {
          addCollectionCards(item.collectionCards || [], { persist: false });
          return;
        }

        if (item.type === "cta") {
          addCta(item.cta || null, { persist: false });
          return;
        }

        if (item.type === "suggestions") {
          addSuggestions(item.suggestions || [], { persist: false });
        }
      });

      body.scrollTop = body.scrollHeight;
    }

    function open() {
      panel.style.display = "block";
      lastPersistedPanelOpen = true;

      restoreChatBodyFromSession();
      persistChatSession();

      setTimeout(function () {
        input.focus();
      }, 50);
    }

    function close() {
      panel.style.display = "none";
      lastPersistedPanelOpen = false;
      persistChatSession();
    }

    function toggle() {
      if (panel.style.display === "block") close();
      else open();
    }

    btn.onclick = open;
    closeBtn.onclick = close;

    window.ConsumerliteChat = {
      open: open,
      close: close,
      toggle: toggle,
      reset: function () {
        resetStoredChatSession();
        restoreChatBodyFromSession();
        persistChatSession();
      },
      version: CONSUMERLITE_CHAT_WIDGET_VERSION,
      storageKey: CHAT_SESSION_STORAGE_KEY
    };

    window.openConsumerliteChat = open;
    window.closeConsumerliteChat = close;

    function isConsumerliteChatTrigger(element) {
      if (!element) return false;

      if (element.closest("[data-consumerlite-chat-open]")) return true;

      const link = element.closest("a");
      if (!link) return false;

      const rawHref = String(link.getAttribute("href") || "").trim();
      if (!rawHref) return false;

      const lowerHref = rawHref.toLowerCase();

      if (
        lowerHref === "#consumerlite-live-chat" ||
        lowerHref === "#live-chat" ||
        lowerHref === "#chat" ||
        lowerHref === "/#consumerlite-live-chat" ||
        lowerHref === "/#live-chat" ||
        lowerHref === "/#chat"
      ) {
        return true;
      }

      try {
        const url = new URL(rawHref, window.location.origin);
        const sameSite = url.origin === window.location.origin;
        const liveChatHash =
          url.hash === "#consumerlite-live-chat" ||
          url.hash === "#live-chat" ||
          url.hash === "#chat";

        return sameSite && liveChatHash;
      } catch (e) {
        return false;
      }
    }

    document.addEventListener("click", function (event) {
      if (!isConsumerliteChatTrigger(event.target)) return;

      event.preventDefault();
      open();

      try {
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, document.title, window.location.pathname + window.location.search);
        }
      } catch (e) {}
    });

    function openFromHashIfNeeded() {
      const hash = String(window.location.hash || "").toLowerCase();
      if (hash === "#consumerlite-live-chat" || hash === "#live-chat" || hash === "#chat") {
        open();

        try {
          if (window.history && window.history.replaceState) {
            window.history.replaceState(null, document.title, window.location.pathname + window.location.search);
          }
        } catch (e) {}
      }
    }

    window.addEventListener("hashchange", openFromHashIfNeeded);
    setTimeout(openFromHashIfNeeded, 250);

    if (lastPersistedPanelOpen) {
      setTimeout(function () {
        open();
      }, 300);
    }

    async function callApi(userText) {
      const endpoint = window.CONSUMERLITE_CHAT_ENDPOINT;
      if (!endpoint) {
        return { reply: "Chat endpoint missing. Please set window.CONSUMERLITE_CHAT_ENDPOINT." };
      }

      const cleanUserText = String(userText || "").trim();
      const payloadContext = Object.assign({}, conversationContext);

      let visiblePriorRequest = "";
      try {
        const userBubbles = Array.prototype.slice.call(body.querySelectorAll(".cl-msg.user .cl-bubble"));
        for (let i = userBubbles.length - 1; i >= 0; i--) {
          const bubbleText = String(userBubbles[i].textContent || "").trim();
          if (!bubbleText) continue;
          if (isAudienceOnlyText(bubbleText)) continue;
          visiblePriorRequest = bubbleText;
          break;
        }
      } catch (e) {}

      let apiMessage = cleanUserText;

      if (isAudienceOnlyText(cleanUserText)) {
        const storedRequest =
          conversationContext.pendingRequest ||
          conversationContext.originalRequest ||
          conversationContext.lastMeaningfulUserText ||
          findLastMeaningfulUserRequest(true) ||
          visiblePriorRequest;

        if (storedRequest) {
          apiMessage = storedRequest + " for " + cleanUserText;

          payloadContext.pendingRequest = storedRequest;
          payloadContext.originalRequest = storedRequest;
          payloadContext.lastMeaningfulUserText = storedRequest;
          payloadContext.visibleMessage = cleanUserText;
          payloadContext.effectiveMessage = apiMessage;
        }
      }

      const payloadHistory = conversationHistory.slice(-24);

      if (apiMessage !== cleanUserText) {
        payloadHistory.push({
          role: "user",
          text: apiMessage
        });
      }

      const res = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          message: apiMessage,
          pageUrl: location.href,
          history: payloadHistory,
          context: payloadContext
        })
      });

      return await res.json();
    }

    async function doSend() {
      const text = (input.value || "").trim();
      if (!text) return;

      input.value = "";
      setUiLanguageFromText(text);
      addMsg("user", text);
      pushHistory("user", text);

      const waitingBubble = addMsg("ai", uiText("ONE_MOMENT"), { persist: false });

      try {
        const data = await callApi(text);
        const replyText = data && data.reply ? sanitizeReplyText(String(data.reply)) : "No reply.";

        waitingBubble.textContent = replyText;
        addUiItem({ type: "msg", role: "ai", text: replyText });
        pushHistory("assistant", replyText);

        rememberPendingRequestIfNeeded(text, replyText);
        mergeContextFromWorker(data);

        const shouldReplaceExtras = Boolean(
          data && (
            (data.showCards && Array.isArray(data.products) && data.products.length) ||
            (data.showCollectionCards && Array.isArray(data.collectionCards) && data.collectionCards.length) ||
            data.cta ||
            (Array.isArray(data.suggestions) && data.suggestions.length)
          )
        );

        if (shouldReplaceExtras) clearOldExtras();

        if (data && data.showCards) {
          addProductCards(data.products);
        } else if (data && data.showCollectionCards) {
          addCollectionCards(data.collectionCards);
        }

        if (data && data.cta) {
          addCta(data.cta);
        }

        if (data && Array.isArray(data.suggestions)) {
          addSuggestions(data.suggestions);
        }
      } catch (e) {
        const fallback = uiText("FALLBACK");
        waitingBubble.textContent = fallback;
        addUiItem({ type: "msg", role: "ai", text: fallback });
        pushHistory("assistant", fallback);
      }
    }

    send.onclick = doSend;
    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter") doSend();
    });

    window.addEventListener("pagehide", function () {
      persistChatSession();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();